/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Number_To_Keep_HelpInputs */



/**
* | output |
* | --- |
* | "Older backups will be automatically removed" |
*
* @param {Options_Backup_Number_To_Keep_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_number_to_keep_help = /** @type {((inputs?: Options_Backup_Number_To_Keep_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Number_To_Keep_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les anciennes sauvegardes seront supprimées automatiquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ältere Backups werden automatisch entfernt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I backup più vecchi verranno rimossi automaticamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Более старые резервные копии будут удалены автоматически.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las copias de seguridad más antiguas se eliminarán automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("较旧的备份将被自动删除。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("古いバックアップは自動的に削除されます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुराने बैकअप अपने आप हटा दिए जाएंगे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os backups mais antigos serão removidos automaticamente.")
	return /** @type {LocalizedString} */ ("Older backups will be automatically removed")
});